import moment from 'moment-wrapper'

const Formats = {
  default (date, userTimeZone) {
    return date.format('LLL') + ' ' + shortAbbr(userTimeZone)
  },
  human (date, userTimeZone) {
    return date.format('MMMM DD') + ' at ' + date.format('LT ') + shortAbbr(userTimeZone)
  },
  human_without_tz (date, userTimeZone) {
    return date.format('LLLL')
  },
  date (date) {
    return date.format('LL')
  },
}

// date can be number (1768397028), string ('2026-05-14 18:34:09 UTC') or JS Date
export function userTimeZoneFormat (userTimeZone, date, format) {
  const isNumber = typeof date === 'number'
  const isDate = date instanceof Date

  // Strip ' UTC' suffix to avoid moment.js deprecation warning about non-ISO format
  const dateValue = isNumber
    ? date * 1000
    : isDate ? date : String(date).replace(/ UTC$/, '')

  const dbTime = isDate ? moment.utc(dateValue) : moment.tz(dateValue, 'UTC')

  if (dbTime.isValid()) {
    return Formats[format || 'default'](dbTime.tz(userTimeZone), userTimeZone)
  } else {
    return null
  }
}

// 'America/Los_Angeles' => 'PST' or 'PDT' or 'UTC-07'
export function shortAbbr (timeZoneId) {
  let tzAbbr = moment().tz(timeZoneId).format('z') // EEST or +07
  if (tzAbbr[0] === '+' || tzAbbr[0] === '-') {
    tzAbbr = 'UTC' + tzAbbr
  }
  return tzAbbr
}

export function getTimeZoneOptions () {
  const now = moment()
  const tzNames = moment.tz.names() // list of unique strings like 'America/Los_Angeles'
  const timeZoneSortKeys = []
  const timeZoneDataByKeys = {}
  const timeZoneOptions = {}
  tzNames.forEach((tzId) => {
    const ts = now.tz(tzId)
    const tzOffset = ts.format('Z') // +07:00
    const tzAbbr = ts.format('z') // EEST or +07
    const tzAbbrAddition = (tzAbbr[0] === '+' || tzAbbr[0] === '-') ? '' : `, ${tzAbbr}`
    const tzText = `(UTC${tzOffset}) ${tzId}${tzAbbrAddition}`
    const sortKey = parseInt(2000 + ts.utcOffset()) + tzId
    timeZoneSortKeys.push(sortKey)
    timeZoneDataByKeys[sortKey] = { id: tzId, text: tzText }
  })

  timeZoneSortKeys.sort()
  timeZoneSortKeys.forEach((tzSortKey) => {
    const tzData = timeZoneDataByKeys[tzSortKey]
    timeZoneOptions[tzData.id] = tzData.text
  })

  return timeZoneOptions
}

export function setMomentLocale (locale, isTimeFormat24) {
  const timeFormat = isTimeFormat24 ? '24' : '12'
  const momentLocale = `${locale}_${timeFormat}`

  moment.locale(momentLocale)
}

// e.g. 'America/Los_Angeles'
export function getGuessedTimezone () {
  return moment.tz.guess()
}

// e.g. 'Europe/Kiev, UTC+03:00, EEST'
export function getGuessedTimezoneFull () {
  const tz = getGuessedTimezone()
  const ts = moment().tz(tz)
  const tzOffset = ts.format('Z') // +07:00
  const tzAbbr = ts.format('z') // EEST or +07
  const tzAbbrAddition = (tzAbbr[0] === '+' || tzAbbr[0] === '-') ? '' : `, ${tzAbbr}`
  const tzText = `${tz}, UTC${tzOffset}${tzAbbrAddition}`
  return tzText
}
